export default class User {
  constructor(staffNo, firstName, lastName, username, email, password, userType) {
    this.staffNo = staffNo;
    this.firstName = firstName;
    this.lastName = lastName;
    this.username = username;
    this.email = email;
    this.password = password;
    this.userType = userType;
  }
}